<template>
  <el-form
    status-icon
    :model="ruleForm"
    :rules="rules"
    label-position="top"
    ref="ruleForm"
    v-loading="loading"
    label-width="120px"
    class="carpo-form demo-ruleForm"
  >
    <el-form-item
      :label="$t('INSPECTION_DATE')"
      prop="vehicle_inspection_expiry_date"
    >
      <date-picker
        :disabled="car.disabled"
        class="el-input__inner"
        v-model="ruleForm.vehicle_inspection_expiry_date"
        view="year"
        format="jYYYY-jMM-jDD"
        :locale="$i18n.locale"
        clearable
      />
    </el-form-item>

    <el-form-item :label="$t('VIN_NUMBER')" prop="vin">
      <el-input
        :disabled="car.disabled"
        type="text"
        v-model="ruleForm.vin"
        autocomplete="off"
      ></el-input>
    </el-form-item>

    <el-form-item :label="$t('LENGTH')" prop="length">
      <el-input-number
        :disabled="car.disabled"
        v-model="ruleForm.length"
        :step="10"
        :min="0"
      ></el-input-number>
    </el-form-item>
    <el-form-item :label="`${$t('WIDTH')} (${$t('METER')})`" prop="width">
      <el-input-number
        :disabled="car.disabled"
        v-model="ruleForm.width"
        :step="10"
        :min="0"
      ></el-input-number>
    </el-form-item>
    <el-form-item :label="`${$t('HEIGHT')} (${$t('METER')})`" prop="height">
      <el-input-number
        :disabled="car.disabled"
        v-model="ruleForm.height"
        :step="10"
        :min="0"
      ></el-input-number>
    </el-form-item>
    <el-form-item
      :label="`${$t('CABIN_CAPACITY')} (${$t('TON')}) `"
      prop="cubic_capacity"
    >
      <el-input-number
        :disabled="car.disabled"
        v-model="ruleForm.cubic_capacity"
        :step="10"
        :min="0"
      ></el-input-number>
    </el-form-item>
    <el-form-item
      :label="`${$t('WEIGHT_CAPACITY')} (${$t('KG')})`"
      prop="weight_capacity"
    >
      <el-input-number
        :disabled="car.disabled"
        v-model="ruleForm.weight_capacity"
        :step="10"
        :min="0"
      ></el-input-number>
    </el-form-item>

    <el-form-item
      :label="$t('CABIN')"
      prop="cabin"
      v-loading="cabinLoading"
      element-loading-spinner="el-icon-loading"
    >
      <el-select
        :disabled="car.disabled"
        :placeholder="$t('SELECT_PLACEHOLDER')"
        v-model="ruleForm.cabin.id"
        clearable
        filterable
      >
        <el-option
          v-for="item in cabins"
          :key="item.id"
          :label="$i18n.locale == 'fa' ? item.fa_title : item.en_title"
          :value="item.id"
        >
        </el-option>
      </el-select>
    </el-form-item>

    <FormConfirmation
      :loading="submitLoading"
      v-if="!car.disabled"
      @resetForm="resetForm('ruleForm')"
      @submitForm="submitForm('ruleForm')"
    />
  </el-form>
</template>
<script>
import { resetForm } from '@/mixins/resetForm'
import { jalaliToGregorian } from '@/mixins/jalaliToGregorian'
import { gregorianToJalali } from '@/mixins/gregorianToJalali'
import {
  editTechnical,
  getTechnical,
  addTechnical,
  carCabins,
} from '@/api/cars'
import FormConfirmation from '@/components/elements/formConfirmation.vue'
import { isNull } from '@/mixins/isNull'

export default {
  mixins: [resetForm, jalaliToGregorian, gregorianToJalali, isNull],
  props: {
    car: {
      type: Object,
      required: false,
    },
  },
  components: {
    FormConfirmation,
  },
  data() {
    return {
      value: [],
      submitLoading: false,
      cabins: [
        {
          id: 1,
          en_title: ' ',
          fa_title: ' ',
        },
      ],
      cabinLoading: true,
      test: null,
      get_car: null,
      loading: true,
      ruleForm: {
        disabled: false,
        third_party_insurance_expiry_date: '',
        vehicle_insurance_expiry_date: '',
        length: '',
        width: '',
        height: '',
        vin: '',
        cubic_capacity: '',
        weight_capacity: '',
        vehicle_inspection_expiry_date: '',
        cabin: {
          id: '',
        },
      },
      rules: {},
    }
  },

  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const actionPayload = {
            cabin: this.ruleForm.cabin.id,
            id: this.$route.params.id,
            company_vehicle: this.$route.params.id,
            vehicle_inspection_expiry_date: this.jalaliToGregorian(
              this.ruleForm.vehicle_inspection_expiry_date,
              this.$i18n.locale
            ),
            length: this.ruleForm.length,
            width: this.ruleForm.width,
            height: this.ruleForm.height,
            cubic_capacity: this.ruleForm.cubic_capacity,
            vin: this.ruleForm.vin,
            weight_capacity: this.ruleForm.weight_capacity,
          }
          var dispatchFunc = this.get_car == null ? addTechnical : editTechnical

          this.submitLoading = true
          dispatchFunc.api(actionPayload).then((res) => {
            this.submitLoading = false
            if (res) {
              this.get_car = res
              this.$notify.success({
                title:
                  this.$t('TECHNICAL_INFO') + ' ' + this.$t('SUCCESSFULLY_'),
                duration: 5000,
                customClass: 'succ_msg',
              })
            }
          })
        } else {
          this.$notify.error({
            title: this.$i18n.t('FIXED_ERRORS', {
              type: this.$i18n.t('TECHNICAL_INFO'),
            }),
            duration: 5000,
            customClass: 'error_msg',
          })
          return false
        }
      })
    },
  },
  created() {
    this.ruleForm = this.car
    getTechnical.api(this.ruleForm.carId).then((res) => {
      this.loading = false
      if (res) {
        res = {
          ...res,
          vehicle_inspection_expiry_date: this.gregorianToJalali(
            res.vehicle_inspection_expiry_date
          ),
          cabin: this.isNull(res.cabin),
        }
        this.ruleForm = res
        this.get_car = res
      }
    })

    carCabins.api().then((res) => {
      if (res) {
        this.cabins = res
        this.cabinLoading = false
      }
    })
  },
}
</script>
